import React, { useState } from "react";
import { FaTrash } from "react-icons/fa";

export default function SalesConfiguration({ uomMaster = [] }) {
  const [discount, setDiscount] = useState("");
  const [isCgstSgstEnabled, setIsCgstSgstEnabled] = useState(false);
  const [isIgstEnabled, setIsIgstEnabled] = useState(false);
  const [cgst, setCgst] = useState("");
  const [sgst, setSgst] = useState("");
  const [igst, setIgst] = useState("");
  const [commissionType, setCommissionType] = useState("Flat");
  const [flatCommissionRate, setFlatCommissionRate] = useState("");
  const [tieredCommissions, setTieredCommissions] = useState([
    { threshold: "", rate: "" },
  ]);
  const [minimumOrderQuantity, setMinimumOrderQuantity] = useState("");
  const [salesUoM, setSalesUoM] = useState("Any of the above"); // Default value

  const handleAddTier = () => {
    setTieredCommissions([...tieredCommissions, { threshold: "", rate: "" }]);
  };

  const handleDeleteTier = (index) => {
    const updatedTiers = tieredCommissions.filter((_, idx) => idx !== index);
    setTieredCommissions(updatedTiers);
  };

  const handleTierChange = (index, field, value) => {
    const updatedTiers = tieredCommissions.map((tier, idx) =>
      idx === index ? { ...tier, [field]: value } : tier
    );
    setTieredCommissions(updatedTiers);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const salesData = {
      discount,
      salesTax: {
        CGST: isCgstSgstEnabled ? cgst : null,
        SGST: isCgstSgstEnabled ? sgst : null,
        IGST: isIgstEnabled ? igst : null,
      },
      commission: {
        type: commissionType,
        flatRate: commissionType === "Flat" ? flatCommissionRate : null,
        tieredRates: commissionType === "Tiered" ? tieredCommissions : null,
      },
      minimumOrderQuantity,
      salesUoM,
    };
    console.log("Sales Configuration Saved:", salesData);
    alert("Sales configuration saved successfully!");
  };

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-700 mb-4">
        Sales Configuration
      </h2>
      <p className="text-gray-500 mb-6">
        Configure sales-related settings and parameters for the item here.
      </p>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Discount */}
        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Discount (%)
          </label>
          <input
            type="number"
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
            placeholder="Enter discount percentage"
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
          />
        </div>

        {/* Sales Tax Type */}
        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Sales Tax Type
          </label>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                className="mr-2"
                checked={isCgstSgstEnabled}
                onChange={(e) => setIsCgstSgstEnabled(e.target.checked)}
              />
              CGST + SGST (Intra-State Sales)
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                className="mr-2"
                checked={isIgstEnabled}
                onChange={(e) => setIsIgstEnabled(e.target.checked)}
              />
              IGST (Inter-State Sales)
            </label>
          </div>
        </div>

        {/* CGST */}
        {isCgstSgstEnabled && (
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              CGST (%)
            </label>
            <input
              type="number"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
              placeholder="Enter CGST percentage"
              value={cgst}
              onChange={(e) => setCgst(e.target.value)}
            />
          </div>
        )}

        {/* SGST */}
        {isCgstSgstEnabled && (
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              SGST (%)
            </label>
            <input
              type="number"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
              placeholder="Enter SGST percentage"
              value={sgst}
              onChange={(e) => setSgst(e.target.value)}
            />
          </div>
        )}

        {/* IGST */}
        {isIgstEnabled && (
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              IGST (%)
            </label>
            <input
              type="number"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
              placeholder="Enter IGST percentage"
              value={igst}
              onChange={(e) => setIgst(e.target.value)}
            />
          </div>
        )}

        {/* Sales UoM */}
        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Sales Unit of Measure (UoM)
          </label>
          <select
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
            value={salesUoM}
            onChange={(e) => setSalesUoM(e.target.value)}
          >
            <option value="Any of the above">Any of the above</option>
            {uomMaster.map((uom) => (
              <option key={uom.value} value={uom.value}>
                {uom.label}
              </option>
            ))}
          </select>
        </div>

        {/* Commission Configuration */}
        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Commission Type
          </label>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="radio"
                name="commissionType"
                className="mr-2"
                value="Flat"
                checked={commissionType === "Flat"}
                onChange={(e) => setCommissionType(e.target.value)}
              />
              Flat Commission
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="commissionType"
                className="mr-2"
                value="Tiered"
                checked={commissionType === "Tiered"}
                onChange={(e) => setCommissionType(e.target.value)}
              />
              Tiered Commission
            </label>
          </div>
        </div>

        {/* Flat Commission Rate */}
        {commissionType === "Flat" && (
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Flat Commission Rate (%)
            </label>
            <input
              type="number"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
              placeholder="Enter flat commission rate"
              value={flatCommissionRate}
              onChange={(e) => setFlatCommissionRate(e.target.value)}
            />
          </div>
        )}

        {/* Tiered Commission Rates */}
        {commissionType === "Tiered" && (
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Tiered Commission Rates
            </label>
            {tieredCommissions.map((tier, index) => (
              <div
                key={index}
                className="flex space-x-4 items-center mb-2 border-b pb-2"
              >
                <input
                  type="number"
                  className="w-1/3 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
                  placeholder="Threshold Value"
                  value={tier.threshold}
                  onChange={(e) =>
                    handleTierChange(index, "threshold", e.target.value)
                  }
                />
                <input
                  type="number"
                  className="w-1/3 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
                  placeholder="Commission Rate (%)"
                  value={tier.rate}
                  onChange={(e) =>
                    handleTierChange(index, "rate", e.target.value)
                  }
                />
                <button
                  type="button"
                  className="px-3 py-2 text-white bg-red-600 rounded-md hover:bg-red-700"
                  onClick={() => handleDeleteTier(index)}
                >
                  <FaTrash />
                </button>
              </div>
            ))}
            <button
              type="button"
              className="mt-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              onClick={handleAddTier}
            >
              Add Tier
            </button>
          </div>
        )}

        {/* Minimum Order Quantity */}
        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Minimum Order Quantity
          </label>
          <input
            type="number"
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
            placeholder="Enter minimum order quantity"
            value={minimumOrderQuantity}
            onChange={(e) => setMinimumOrderQuantity(e.target.value)}
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Save Configuration
        </button>
      </form>
    </div>
  );
}
